var map = {
	"./demos/basic/index.ts": 60294,
	"./demos/complex/index.ts": 82459,
	"./demos/nested/index.ts": 97154,
	"./demos/range/index.ts": 81929,
	"./demos/vertical/index.ts": 49780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52607;